import { c as _c } from "react/compiler-runtime";
import type { CreateAgentCredentialRequest } from '@onefootprint/request-types/dashboard';
import { Button, Form } from '@onefootprint/ui';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { BrowserAsk } from '../../../utils/chat-segments';
type FormValues = {
  username: string;
  password: string;
  remember: boolean;
};
type CredentialPasswordFormProps = {
  ask: Extract<BrowserAsk, {
    kind: 'credential';
  }>;
  pending: boolean;
  onSave: (body: CreateAgentCredentialRequest) => void;
  onUseOnePassword: () => void;
};
const CredentialPasswordForm = t0 => {
  const $ = _c(51);
  const {
    ask,
    pending,
    onSave,
    onUseOnePassword
  } = t0;
  const {
    t
  } = useTranslation("copilot");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      defaultValues: DEFAULT_VALUES
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const formMethods = useForm(t1);
  let T0;
  let t2;
  let t3;
  let t4;
  if ($[1] !== ask.origin || $[2] !== formMethods || $[3] !== onSave) {
    const origin = originOf(ask.origin);
    const onSubmit = t5 => {
      const {
        username,
        password,
        remember
      } = t5;
      if (origin === null) {
        return;
      }
      onSave({
        provider: {
          kind: "static_credential",
          allowedOrigins: [origin],
          username,
          password
        },
        agentIds: [],
        temporary: !remember
      });
    };
    T0 = FormProvider;
    t4 = formMethods;
    t2 = "flex flex-col gap-5";
    t3 = formMethods.handleSubmit(onSubmit);
    $[1] = ask.origin;
    $[2] = formMethods;
    $[3] = onSave;
    $[4] = T0;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    T0 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t(_temp);
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t(_temp2);
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <Form.Input name="username" size="compact" label={t5} placeholder={t6} autoComplete="username" autoCapitalize="none" autoCorrect="off" spellCheck={false} autoFocus={true} required={true} />;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t(_temp3);
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t(_temp4);
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t8 || $[20] !== t9) {
    t10 = <Form.Input name="password" size="compact" type="password" label={t8} placeholder={t9} autoComplete="current-password" required={true} data-dd-privacy="mask" />;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t) {
    t11 = t(_temp5);
    $[22] = t;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11) {
    t12 = <Form.Toggle name="remember" size="compact" label={t11} />;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t) {
    t13 = t(_temp6);
    $[26] = t;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== pending || $[29] !== t13) {
    t14 = <Button type="submit" variant="primary" size="compact" loading={pending}>{t13}</Button>;
    $[28] = pending;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t) {
    t15 = t(_temp7);
    $[31] = t;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== onUseOnePassword || $[34] !== pending || $[35] !== t15) {
    t16 = <Button type="button" variant="secondary" size="compact" disabled={pending} onClick={onUseOnePassword}>{t15}</Button>;
    $[33] = onUseOnePassword;
    $[34] = pending;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t14 || $[38] !== t16) {
    t17 = <div className="flex items-center gap-2">{t14}{t16}</div>;
    $[37] = t14;
    $[38] = t16;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== t10 || $[41] !== t12 || $[42] !== t17 || $[43] !== t2 || $[44] !== t3 || $[45] !== t7) {
    t18 = <form className={t2} onSubmit={t3}>{t7}{t10}{t12}{t17}</form>;
    $[40] = t10;
    $[41] = t12;
    $[42] = t17;
    $[43] = t2;
    $[44] = t3;
    $[45] = t7;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] !== T0 || $[48] !== t18 || $[49] !== t4) {
    t19 = <T0 {...t4}>{t18}</T0>;
    $[47] = T0;
    $[48] = t18;
    $[49] = t4;
    $[50] = t19;
  } else {
    t19 = $[50];
  }
  return t19;
};
const DEFAULT_VALUES: FormValues = {
  username: '',
  password: '',
  remember: false
};
const originOf = (url: string): string | null => {
  try {
    const parsed = new URL(url);
    return parsed.host ? parsed.origin : null;
  } catch {
    return null;
  }
};
export default CredentialPasswordForm;
function _temp($) {
  return $.chat.browser.credential.username;
}
function _temp2($_0) {
  return $_0.chat.browser.credential.usernamePlaceholder;
}
function _temp3($_1) {
  return $_1.chat.browser.credential.password;
}
function _temp4($_2) {
  return $_2.chat.browser.credential.passwordPlaceholder;
}
function _temp5($_3) {
  return $_3.chat.browser.credential.remember;
}
function _temp6($_4) {
  return $_4.chat.browser.credential.submit;
}
function _temp7($_5) {
  return $_5.chat.browser.credential.useOnePassword;
}